<pr-panel [clazz]="'man ' + clazz">
  <pr-panel-header [title]="headerTitle || null">
    <ng-content panelHeader select="[tableHeader]"></ng-content>
    <ng-content select="[tableHeaderRight]"></ng-content>
  </pr-panel-header>
  <pr-panel-body>
    <div
      class="pr-card-swiper animated fadeIn relative overflow-hidden"
      [ngClass]="{ 'pr-card-mobile': mdq?.matches, 'pr-card-dense': dense }"
      [hidden]="!tableData?.data?.length"
    >
      <div class="pr-table-card-container">
        <div class="pr-table-card-row-container pr-table-card-headings">
          <th
            *ngFor="let column of tableData?.columns"
            [attr.data-type]="column.type"
            [tooltip]="column.label"
            (click)="sort(column)"
            [ngClass]="
              (column.options.span
                ? 'grid-span-' + column.options.span || 1
                : '') +
              ' bg-color' +
              (column.options.class ? column.options.class : ' ') +
              (column.options?.colored ? ' colored' : ' ')
            "
            [style]="column.options.styleCol ? column.options.styleCol : ' '"
          >
            <span
              [style]="
                column.options.styleTitle ? column.options.styleTitle : ''
              "
              class="pr-table-card-cell text-ellipsis uppercase"
              >{{ column.shortlabel ? column.shortlabel : column.label }}
              <pr-icon
                *ngIf="column.label && sortColumn.name == column.name"
                [name]="'filter_list'"
                [ngClass]="{ flip: sortColumn.way == 'asc' }"
                [width]="12"
              ></pr-icon>
            </span>
          </th>
        </div>
        <div class="pr-table-card-statistics-body">
          <ng-container
            [ngTemplateOutlet]="mdq?.matches ? mobileDisplay : desktopDisplay"
          ></ng-container>
        </div>
      </div>
    </div>

    <div
      class="empty-table-container"
      *ngIf="tableData?.data?.length == 0 && !showLoader"
    >
      <div>
        <ng-content select="[emptyTemplate]"></ng-content>
      </div>
    </div>

    <div class="empty-table-container" *ngIf="showLoader">
      <div>
        <div class="lds-roller">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
    </div>
  </pr-panel-body>
</pr-panel>

<ng-template #desktopDisplay>
  <ng-container class="desktop">
    <ng-container
      *ngFor="let item of sortBy(); index as i; last as isLast"
      [ngTemplateOutlet]="tableContent"
      [ngTemplateOutletContext]="{
        $implicit: {
          row: tableData.data[i],
          columns: tableData.columns,
          isLast: isLast,
        },
      }"
    >
    </ng-container>
  </ng-container>

  <ng-container>
    <ng-container
      [ngTemplateOutlet]="tableContent"
      *ngIf="tableData && hasTotal"
      [ngTemplateOutletContext]="{
        $implicit: {
          row: totalColumn,
          columns: tableData.columns,
          isLast: false,
          isTotal: true,
        },
      }"
    >
    </ng-container>
  </ng-container>
</ng-template>

<ng-template #mobileDisplay>
  <pr-swiper
    swiperMinWidth="992"
    *ngIf="tableData?.data?.length"
    [config]="config"
  >
    <pr-slide *ngFor="let slide of tableData?.data; index as i; last as isLast">
      <ng-container
        [ngTemplateOutlet]="tableContent"
        [ngTemplateOutletContext]="{
          $implicit: {
            row: tableData.data[i],
            columns: tableData.columns,
            isLast: isLast,
          },
        }"
      >
      </ng-container>
    </pr-slide>
    <pr-slide *ngIf="tableData && hasTotal">
      <ng-container
        [ngTemplateOutlet]="tableContent"
        *ngIf="tableData && hasTotal"
        [ngTemplateOutletContext]="{
          $implicit: {
            row: totalColumn,
            columns: tableData.columns,
            isLast: false,
            isTotal: true,
          },
        }"
      >
      </ng-container>
    </pr-slide>
  </pr-swiper>
</ng-template>

<ng-template #tableHeader> </ng-template>

<ng-template #tableContent let-data>
  <div
    [class]="
      'pr-table-card-row ' +
      (data.isTotal ? 'pr-table-card-row-total' : '') +
      ' ' +
      getRowClass(data.row, data.isTotal)
    "
    (click)="rowClick.emit(data.row)"
  >
    <div class="pr-table-card-row-container pointer">
      <div
        class="pr-table-card-cell text-ellipsis"
        [tooltip]="column.options?.tooltip ? data.row[column.name] : undefined"
        [ngClass]="
          (column.options?.span
            ? 'grid-span-' + column.options.span || 1
            : '') +
          ' ' +
          (column.options.class ? column.options.class : '') +
          (column.options?.colored ? getColumnClass(data.row[column.name]) : '')
        "
        *ngFor="let column of data.columns; index as i"
        [attr.data-label]="column.label"
        [attr.data-name]="column.name"
        [attr.data-type]="column.type"
        [ngSwitch]="column.type"
        [style]="column.options.styleCol ? column.options.styleCol : ''"
      >
        <!-- Total -->
        <div
          *ngIf="
            data.isTotal &&
              (column.options?.hasOwnProperty('customTotalValue') || i == 0);
            else defaultDisplay
          "
          class="fw-600 total-cell"
          [style]="
            column.options.styleColInside ? column.options.styleColInside : ''
          "
        >
          {{ data.row[column.name] }}
        </div>
        <!-- Standard row -->
        <ng-template #defaultDisplay>
          <div
            class="d-flex align-items-center"
            [style]="
              column.options.styleColInside ? column.options.styleColInside : ''
            "
          >
            <span
              [innerHTML]="column.options.prefix"
              *ngIf="
                (!data.isTotal && column.options.prefix) ||
                (data.isTotal &&
                  column.options.prefix &&
                  column.options.hasTotal)
              "
              style="margin-right: 3px"
            ></span>
            <span
              class="d-flex flex-column text-ellipsis"
              [class]="column.options.class"
              *ngIf="!data.isTotal || (data.isTotal && column.options.hasTotal)"
            >
              <ng-container *ngSwitchDefault>
                <ng-container
                  *ngIf="data?.row[column?.name]?.name; else defaultRowDisplay"
                >
                  <span class="fs-12 fc-ter uppercase">{{
                    data.row[column.name].isinCode
                  }}</span>
                  <span class="fw-600 ws-nw">{{
                    data.row[column.name].name
                  }}</span>
                </ng-container>
                <ng-template #defaultRowDisplay
                  ><span class="text-ellipsis">
                    {{ data.row[column.name] }}
                  </span></ng-template
                >
              </ng-container>

              <ng-container *ngSwitchCase="'capitalize'">
                {{ data.row[column.name] | titlecase }}
              </ng-container>

              <ng-container *ngSwitchCase="'function'">{{
                column.name(data.row)
              }}</ng-container>

              <ng-container *ngSwitchCase="'currency'">{{
                data.row[column.name] | currency: 'EUR' : 'symbol' : '.0-2'
              }}</ng-container>
              <!-- TODO must be fixed and add percent not percent-number see where we use it -->
              <ng-container *ngSwitchCase="'percent-number'"
                >{{ data.row[column.name] }} %</ng-container
              >

              <ng-container *ngSwitchCase="'badge'">
                <span class="pr-badge">{{
                  data.row[column.name] | titlecase
                }}</span>
              </ng-container>

              <ng-container *ngSwitchCase="'input'">
                <span
                  *ngIf="column.options.totalText && data.isTotal"
                  class="full-w"
                  >{{ data.row[column.name] }}</span
                >
                <input
                  *ngIf="!(column.options.totalText && data.isTotal)"
                  class="full-w"
                  [value]="roundIfNumber(data.row[column.name])"
                  [disabled]="column.options?.disabled ? column.options.disabled(data.row) : false"
                  (change)="
                    inputChanged($event.target.value, data.row, column)
                  "
                />
              </ng-container>

              <ng-container *ngSwitchCase="'select'">
                <pr-select
                  [value]="data.row[column.name]"
                  [options]="column.options.selectOptions"
                  [updateOptions]="column.options.updateSelectOptions"
                  [disabled]="column.options?.disabled ? column.options.disabled(data.row) : false"
                  (onSelectionChange)="
                    inputChanged($event, data.row, column)
                  "
                >
                </pr-select>
              </ng-container>

              <ng-container *ngSwitchCase="'flag'">
                <pr-icon
                  [name]="'fs-' + data.row.flag"
                  style="margin-right: 5px"
                ></pr-icon>
                {{ data.row[column.name] }}
              </ng-container>

              <ng-container *ngSwitchCase="'html'">
                <div [innerHTML]="data.row[column.name] | prSafeHtml"></div>
              </ng-container>

              <ng-container *ngSwitchCase="'async'"
                >{{ data.row[column.name] | async }}
              </ng-container>

              <ng-container *ngSwitchCase="'bool'"
                >{{ data.row[column.name] ? 'Oui' : 'Non' }}
              </ng-container>

              <ng-container *ngSwitchCase="'check'">
                <ng-container [ngSwitch]="true">
                  <pr-icon
                    *ngSwitchCase="data.row[column.name]"
                    name="sp-check-opti"
                    [viewBoxWidth]="16"
                    [viewBoxHeight]="16"
                    [width]="16"
                    [height]="16"
                  ></pr-icon>
                  <pr-icon
                    *ngSwitchDefault
                    name="fa-close"
                    [viewBoxWidth]="16"
                    [viewBoxHeight]="16"
                    [width]="16"
                    [height]="16"
                  ></pr-icon>
                </ng-container>
              </ng-container>

              <ng-container *ngSwitchCase="'date'"
                >{{ data.row[column.name] | date: 'shortDate' }}
              </ng-container>

              <ng-container *ngSwitchCase="'datetime'"
                >{{ data.row[column.name] | date: 'short' }}
              </ng-container>

              <ng-container *ngSwitchCase="'progress'">
                <div class="d-flex progress-div">
                  <pr-progress
                    [progress]="data.row[column.name]"
                    [rounded]="true"
                    color="#ce9f47"
                    [hidden]="!data.row[column.name]"
                    bgColor="var(--bg-rdv-card)"
                    [displayText]="false"
                    height="12px"
                  >
                  </pr-progress>
                  <span class="progress-span fs-14"
                    >{{ data.row[column.name] }} %</span
                  >
                </div>
              </ng-container>

              <ng-container *ngSwitchCase="'star'">
                <div class="d-flex star">
                  <div *ngFor="let star of _.range(5); let i = index">
                    <pr-icon
                      *ngIf="data.row[column.name] >= i + 1"
                      name="star"
                    ></pr-icon>
                    <pr-icon
                      *ngIf="data.row[column.name] < i + 1"
                      #outline
                      name="star_outline"
                    >
                    </pr-icon>
                  </div>
                </div>
              </ng-container>

              <ng-container *ngSwitchCase="'action'">
                <div (click)="$event.stopPropagation()">
                  <ng-container *ngIf="!data.isTotal">
                    <ng-container
                      *ngTemplateOutlet="
                        actionsTemplate;
                        context: { $implicit: data.row }
                      "
                    >
                    </ng-container>
                  </ng-container>
                </div>
              </ng-container>

              <ng-container *ngSwitchCase="'duration'">
                <em
                  *ngIf="
                    column.options.durationFutur &&
                    data.row[column.name] < today.toISOString()
                  "
                  >Terminé depuis
                </em>
                {{
                  column.options.durationFutur &&
                  data.row[column.name] < today.toISOString()
                    ? (data.row[column.name] | prDuration: false)
                    : (data.row[column.name] | prDuration: true)
                }}
              </ng-container>
            </span>

            <span
              [innerHTML]="column.options.suffix"
              *ngIf="
                (!data.isTotal && column.options.suffix) ||
                (data.isTotal &&
                  column.options.suffix &&
                  column.options.hasTotal)
              "
              style="margin-left: 3px"
            ></span>
          </div>
        </ng-template>
      </div>
    </div>
  </div>
</ng-template>
